import React, { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from "./ProtectedRoute";

import Home from './Pages/Home';
import Donation from './Pages/Donation';
import Founder from './Pages/Founder';
import User from './Pages/User';
import Blog from './Pages/Blog';
import Disclaimer from './Pages/Disclaimer';
import Privacy from './Pages/Privacy';
import Terms from './Pages/Terms';
import Knowmore from './Pages/Knowmore';
import CompanyDetails from './Pages/CompanyDetails';
import AboutUs from './Pages/AboutUs';
import AllAdvs from './Pages/AllAdvs';
import Login from './Pages/Login';
import LoginAdmin from './Pages/LoginAdmin';
import Signup from './Pages/Signup';
import VerifyUser from './Pages/VerifyUser';
import ContactPage from './Pages/ContactPage';
import ForgotPassword from './Pages/Common/ForgotPassword';
import AddUser from './Pages/AddUser';
import Advertisements from './Pages/Advertisements';
import AddAdv from './Pages/AddAdv';
import VerifyPayment from './Pages/VerifyPayment';
import Inquiries from './Pages/Inquiries';
import Locations from './Pages/Locations';
import AddLocation from './Pages/AddLocation';


const Dashboard = lazy(() => import("./Pages/Dashboard"));

export default function Mainroutes(props) {
    return (
        <BrowserRouter>
            <Routes>
                <Route exact path='/' element={<Home />} />
                <Route exact path='/home' element={<Home />} />
                <Route exact path='/about-us' element={<AboutUs />} />
                <Route exact path='/founder' element={<Founder />} />
                <Route exact path='/user' element={<User />} />
                <Route exact path='/blog' element={<Blog />} />
                <Route exact path='/advs' element={<AllAdvs />} />
                <Route exact path='/disclaimer' element={<Disclaimer />} />
                <Route exact path='/privacy' element={<Privacy />} />
                <Route exact path='/terms-service' element={<Terms />} />
                <Route exact path='/know-more' element={<Knowmore />} />
                <Route exact path='/company-details/:id' element={<CompanyDetails />} />
                <Route exact path='/verify_payment' element={<VerifyPayment />} />
                <Route exact path='/founder-login' element={<Login />} />
                <Route exact path='/founder-signup' element={<Signup />} />
                <Route exact path='/user-login' element={<Login />} />
                <Route exact path='/admin' element={<LoginAdmin />} />
                <Route exact path='/user-signup' element={<Signup />} />
                <Route exact path='/verifyUser' element={<VerifyUser />} />
                <Route exact path='/forgot-password' element={<ForgotPassword />} />
                <Route exact path='/donation-for-indian-army' element={<Donation />} />
                <Route element={<ProtectedRoute />}>
                    <Route exact path='/dashboard' element={<Dashboard />} />
                    <Route exact path='/add-user' element={<AddUser />} />
                    <Route exact path='/advertisements' element={<Advertisements />} />
                    <Route exact path='/add-advertise' element={<AddAdv />} />
                    <Route exact path='/inquiries' element={<Inquiries />} />
                    <Route exact path='/locations' element={<Locations />} />
                    <Route exact path='/add-new-location' element={<AddLocation />} />
                </Route>
                <Route exact path='/contact-us' element={<ContactPage />} />
            </Routes>
        </BrowserRouter>
    );
}
